// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_m9-0";
export var discountCodeInput = "_m9-1";